import React, { useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { signup } from '../actions/auth';
import Footer from './Footer';

import SlideIn from "../components/animations/SlideIn";
import FadeIn from "../components/animations/FadeIn";


const Signup = ({ signup, isAuthenticated }) => {
    const [accountCreated, setAccountCreated] = useState(false);
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        re_password: ''
    });

    const { first_name, last_name, email, password, re_password } = formData;

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = e => {
        e.preventDefault();

        if (password === re_password) {
            signup(first_name, last_name, email, password, re_password);
            setAccountCreated(true);
        }
    };


    if (isAuthenticated) {
        return <Redirect to='/login' />
    }
    if (accountCreated) {
        return <Redirect to='/login' />
    }

    return (
        <>
        <br/><br/>
        <div className="signup-bg-image image-background">
            <FadeIn>
                <h1 style={{textAlign: 'center', color: 'white', paddingTop: '30px', fontFamily: 'Lobster'}}>Lets Connect!</h1>
            </FadeIn>
	    
            <SlideIn>
                <div className="d-flex justify-content-center h-100">
                    <div className="card" style={{height: '420px',marginBottom: '60px',width: '400px'}}>
                        <div className="card-header">
                            <h3>Sign Up</h3>
                        </div>
                        <div className="card-body">
                        <form onSubmit={e => onSubmit(e)}>
                            <div className="input-group form-group">
                            <span className="input-group-text blue-theme-color" style={{width:'55px'}}><i className="fa fa-user ml-2"></i></span>
                                <input
                                    className='form-control'
                                    type='text'
                                    placeholder='First Name*'
                                    name='first_name'
                                    value={first_name}
                                    onChange={e => onChange(e)}
                                    required
                                />
                            </div>
                            <div className="input-group form-group">
                            <span className="input-group-text blue-theme-color" style={{width:'55px'}}><i className="fa fa-user ml-2"></i></span>
                                <input
                                    className='form-control'
                                    type='text'
                                    placeholder='Last Name*'
                                    name='last_name'
                                    value={last_name}
                                    onChange={e => onChange(e)}
                                    required
                                /> 
                            </div>
                            <div className="input-group form-group">
                            <span className="input-group-text blue-theme-color" style={{width:'55px'}}><i className="fa fa-envelope ml-2"></i></span>
                                <input
                                    className='form-control'
                                    type='email'
                                    placeholder='Email*'
                                    name='email'
                                    value={email}
                                    onChange={e => onChange(e)}
                                    required
                                />
                            </div>
                            
                            
                            <div className="input-group form-group">
                                <span className="input-group-text blue-theme-color" style={{width:'55px'}}><i className="fa fa-key ml-2"></i></span>
                                <input
                                    className='form-control'
                                    type='password'
                                    placeholder='Password*'
                                    name='password'
                                    value={password}
                                    pattern='.{8,}' 
                                    title='Please Enter 8 characters minimum' 
                                    onChange={e => onChange(e)}
                                    minLength='8'
                                    required
                                />
                            </div>
                            <div className="input-group form-group">
                                <span className="input-group-text blue-theme-color" style={{width:'55px'}}><i className="fa fa-key ml-2"></i></span>
                                <input
                                    className='form-control'
                                    type='password'
                                    placeholder='Confirm Password*'
                                    name='re_password'
                                    value={re_password}
                                    pattern='.{8,}'
                                    title='Please Enter 8 characters minimum' 
                                    onChange={e => onChange(e)}
                                    minLength='6'
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <button className='btn btn-primary float-right blue-theme-color' type='submit' style={{width: '100px'}}>Register</button>
                            </div>
                        </form>
                        </div>
                        <div className="card-footer">
                            <div className="d-flex justify-content-center links">
                                Already have an account?<Link to='/login'>Log in</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </SlideIn>
		</div>
        
        <Footer />
        </>
    );
};

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps, { signup })(Signup);
